import { render, staticRenderFns } from "./LandingPageWhatAdditionalCoverComponent.vue?vue&type=template&id=3806939e&scoped=true&"
import script from "./LandingPageWhatAdditionalCoverComponent.vue?vue&type=script&lang=js&"
export * from "./LandingPageWhatAdditionalCoverComponent.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageWhatAdditionalCoverComponent.vue?vue&type=style&index=0&id=3806939e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3806939e",
  null
  
)

export default component.exports